import { BASE_API_URL } from "../../../../config/url"

export const SIGNUP_DONE = 'SIGNUP DONE';

export const  SIGNUP_API_URL = `${BASE_API_URL}/onboarding/user/register`;

export const  REFRESH_TOKEN_API_URL = `${BASE_API_URL}/onboarding/user/refresh-token`;

